export const CLOSE_ALL = '[DASH] CLOSE ALL';
export const OPEN_SUMMARY = '[DASH] OPEN SUMMARY';
export const CLOSE_SUMMARY = '[DASH] CLOSE SUMMARY';
export const TOGGLE_SUMMARY = '[DASH] TOGGLE SUMMARY';
export const TOGGLE_REPORTS = '[DASH] TOGGLE REPORTS';

export function closeAllPanels() {
    return {
        type: CLOSE_ALL
    }
}

export function openSummary() {
    return {
        type: OPEN_SUMMARY
    }
}

export function closeSummary() {
    return {
        type: CLOSE_SUMMARY
    }
}

export function toggleSummary() {
    return {
        type: TOGGLE_SUMMARY
    }
}

export function toggleReports() {
    return {
        type: TOGGLE_REPORTS
    }
}